import { IModeChooser } from "@/components/excel/schema/definiens/mode";
import {
  findModeOption,
  MultiSelector,
  SingleSelector,
} from "@/components/excel/schema/label/mode";
import Arrays from "@/utils/extensions/Arrays";
import {
  buildCommonTransfer,
  checkMode,
  commonTransfer,
} from "@/components/excel/schema/label/transfer/base";
import {
  CityOption,
  CountyOption,
  ProvinceOption,
} from "@/components/excel/schema/label/type/area";
import { SexOption } from "@/components/excel/schema/label/type/other";

const areaDeepType: { [key: number]: string } = {
  2: "city",
  3: "county",
};
function areaChildTransfer(
  value: number[] | Array<number | Array<number>>[],
  mode: number,
  deep: number,
  chooser?: IModeChooser
): number[][] {
  checkMode(mode, chooser);
  if (mode === SingleSelector.value) {
    if (Arrays.isSingleTypeArray(value)) {
      if (value.length !== deep) {
        const msg = `单选${areaDeepType[deep]},期待的值应该是长度为${deep}的一维整数数组,而不是`;
        console.error(msg, value);
        throw new Error(`${msg}长度为${value.length}`);
      }
      return [value];
    }
    const msg = `单选${areaDeepType[deep]},期待的值应该是一维整数数组`;
    console.error(`${msg},而不是`, value);
    throw new Error(msg);
  }
  if (mode === MultiSelector.value) {
    const result: number[][] = [];
    if (!Arrays.isTowDimensionArray(value)) {
      const msg = `多选${areaDeepType[deep]},期待的值应该是二维数组`;
      console.error(`${msg}, 而不是`, value);
      throw new Error(msg);
    }
    value.forEach((row) => {
      if (row.length !== deep) {
        const msg = `多选${areaDeepType[deep]},期待的值应该是子元素数组长度为${deep}的二维数组, 而不是`;
        console.error(msg, value);
        throw new Error(`${msg}长度为${row.length}`);
      }
      const grands: number[] = [];
      row.forEach((item) => {
        if (Array.isArray(item)) {
          const array = item.map((it) => [...grands, it]);
          result.pushArray(array);
        } else {
          grands.push(item);
        }
      });
    });
    return result;
  }
  const obj = findModeOption(mode);
  console.error("输入方式只支持单选和多选, 而不是", mode, obj);
  throw new Error(`${areaDeepType[deep]}不支持输入方式:${obj?.text}`);
}

export const AreaValueTransfer = {
  ...buildCommonTransfer(ProvinceOption),
  [CityOption.value]: function (
    value: number[] | Array<number | Array<number>>[],
    mode: number
  ): number[][] {
    return areaChildTransfer(value, mode, 2, CityOption.mode);
  },
  [CountyOption.value]: function (
    value: number[] | Array<number | Array<number>>[],
    mode: number
  ): number[][] {
    return areaChildTransfer(value, mode, 3, CountyOption.mode);
  },
};
